import api from 'services/technical-visit/finish-technical-visit'

export const handleSave = async (values: any) => {
  let res = await api.finishEquipment(values)

  return res?.data?.success
}
